import { useEffect, useState } from "react";
import "@/App.css";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import ArcadeNav from "@/components/ArcadeNav";
import FireLogo from "@/components/FireLogo";
import HomePage from "@/components/HomePage";
import GameHero from "@/components/GameHero";
import Marquee from "@/components/Marquee";
import ShopGallery from "@/components/ShopGallery";
import CustomSticks from "@/components/CustomSticks";
import Manifesto from "@/components/Manifesto";
import SiteFooter from "@/components/SiteFooter";

export default function App() {
    const [view, setView] = useState("home");
    const [flash, setFlash] = useState(true);

    useEffect(() => {
        const t = setTimeout(() => setFlash(false), 1700);
        return () => clearTimeout(t);
    }, []);

    const navigate = (v) => {
        if (v === view) return;
        setFlash(true);
        setView(v);
        setTimeout(() => setFlash(false), 800);
    };

    useEffect(() => {
        document.documentElement.style.overflow = view === "game" ? "hidden" : "";
        window.scrollTo(0, 0);
    }, [view]);

    return (
        <div className="App">
            {/* game stays mounted so score/combo survive page switches */}
            <div className={view === "game" ? "" : "hidden"}>
                <GameHero onNavigate={navigate} visible={view === "game"} />
            </div>

            {view !== "game" && view !== "home" && (
                <div className="sticky top-0 z-40 border-b border-[#2A2A36] bg-[#060608]/95 px-4 py-3 backdrop-blur">
                    <ArcadeNav active={view} onNavigate={navigate} />
                </div>
            )}

            <AnimatePresence mode="wait">
                {view !== "game" && (
                    <motion.div
                        key={view}
                        initial={{ opacity: 0, y: 18 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -14 }}
                        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                    >
                        {view === "home" && <HomePage onNavigate={navigate} />}
                        {view === "shop" && (
                            <>
                                <ShopGallery />
                                <Marquee />
                                <SiteFooter />
                            </>
                        )}
                        {view === "custom" && (
                            <>
                                <CustomSticks />
                                <SiteFooter />
                            </>
                        )}
                        {view === "brand" && (
                            <>
                                <Manifesto />
                                <SiteFooter />
                            </>
                        )}
                    </motion.div>
                )}
            </AnimatePresence>
            <AnimatePresence>
                {flash && (
                    <motion.div
                        data-testid="fire-transition-overlay"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.22 }}
                        className="fixed inset-0 z-[70] flex flex-col items-center justify-center gap-7 bg-[#060608]"
                    >
                        <FireLogo />
                        <span className="blink font-pixel text-[8px] tracking-[0.35em] text-[#FF9500]">
                            FIRING UP…
                        </span>
                    </motion.div>
                )}
            </AnimatePresence>
            <Toaster theme="dark" position="bottom-center" />
        </div>
    );
}
